import { useEffect } from 'react';
import { path } from 'ramda';
import { useOtherSettings } from '@namespace/cms';
import { sportsbookActions } from '../../store';

const { REMOVE_LINE } = sportsbookActions;

// removes line from sportsbook state.lines on line component
// unmount to unsubscribe from rendered events
export const useRemoveLine = (lineKey, force = false) => {
  const otherSettings = useOtherSettings();
  const disableLineCaching = path(
    ['sports', 'disableLineCaching'],
    otherSettings
  );

  useEffect(
    () => () => {
      if (force || disableLineCaching) {
        REMOVE_LINE({ lineKey });
      }
    },
    [disableLineCaching, force, lineKey]
  );
};
